var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3349 16.5323V18.0361C11.3349 18.7084 10.7909 19.2563 10.1147 19.2563H2.72013C2.04789 19.2563 1.5 18.7122 1.5 18.0361V16.5323H11.3349Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09064 17.1152C1.99349 17.1152 1.89635 17.0919 1.80698 17.0414C1.5272 16.8859 1.42617 16.5285 1.5816 16.2487L5.91035 8.46549C6.06578 8.18571 6.41938 8.08079 6.70304 8.2401C6.98282 8.39553 7.08385 8.75303 6.92842 9.0328L2.59967 16.816C2.49476 17.0064 2.2927 17.1152 2.09064 17.1152Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.752 17.1579C10.5461 17.1579 10.3479 17.0491 10.243 16.8587L5.91035 9.03279C5.75492 8.75302 5.85595 8.39553 6.13961 8.24009C6.41938 8.08466 6.77687 8.18569 6.93231 8.46935L11.2649 16.2953C11.4204 16.5751 11.3193 16.9326 11.0357 17.088C10.9463 17.1385 10.8492 17.1618 10.752 17.1618V17.1579Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 9.332H6.41938C6.09686 9.332 5.83652 9.07165 5.83652 8.74914C5.83652 8.42662 6.09686 8.16627 6.41938 8.16627H15.5004C15.8229 8.16627 16.0833 8.42662 16.0833 8.74914C16.0833 9.07165 15.8229 9.332 15.5004 9.332Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2768 19.2563H20.8822C20.21 19.2563 19.6621 18.7122 19.6621 18.0361V16.5323H29.4931V18.0361C29.4931 18.7084 28.9491 19.2563 28.2729 19.2563H28.2768Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.918 17.1152C28.712 17.1152 28.5139 17.0064 28.409 16.816L24.0685 9.0328C23.9131 8.75303 24.0141 8.39553 24.2939 8.2401C24.5737 8.08079 24.9312 8.18571 25.0866 8.46549L29.427 16.2487C29.5825 16.5285 29.4814 16.8859 29.2016 17.0414C29.1123 17.0919 29.0151 17.1152 28.918 17.1152Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 17.1152C20.1478 17.1152 20.0507 17.0919 19.9613 17.0414C19.6815 16.8859 19.5805 16.5285 19.7359 16.2487L24.0685 8.46549C24.224 8.18571 24.5815 8.08079 24.8612 8.2401C25.141 8.39553 25.2421 8.75303 25.0866 9.0328L20.754 16.816C20.6491 17.0064 20.447 17.1152 20.2449 17.1152Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5776 9.332H15.5004C15.1779 9.332 14.9176 9.07165 14.9176 8.74914C14.9176 8.42662 15.1779 8.16627 15.5004 8.16627H24.5776C24.9001 8.16627 25.1604 8.42662 25.1604 8.74914C25.1604 9.07165 24.9001 9.332 24.5776 9.332Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4732 26.8257C15.1507 26.8257 14.8904 26.5654 14.8904 26.2429V3.9541C14.8904 3.63158 15.1507 3.37123 15.4732 3.37123C15.7957 3.37123 16.0561 3.63158 16.0561 3.9541V26.2429C16.0561 26.5654 15.7957 26.8257 15.4732 26.8257Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 10.5133C16.4747 10.5133 17.2646 9.72344 17.2646 8.74914C17.2646 7.77483 16.4747 6.985 15.5004 6.985C14.5261 6.985 13.7363 7.77483 13.7363 8.74914C13.7363 9.72344 14.5261 10.5133 15.5004 10.5133Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 5.05765C16.1121 5.05765 16.6079 4.56183 16.6079 3.95021C16.6079 3.33858 16.1121 2.84277 15.5004 2.84277C14.8888 2.84277 14.393 3.33858 14.393 3.95021C14.393 4.56183 14.8888 5.05765 15.5004 5.05765Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.153 23.4995H11.7973V25.9398H19.153V23.4995Z",
    fill: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8861 25.3025H10.2741V27.1755H20.8861V25.3025Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.c7e83468124a6dee62f48dbb68e597b1.svg";
export { ForwardRef as ReactComponent };